// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"format-painter"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M10 16H14V21H10z"}},{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 3H19V6.5V10H4V3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19 6.5V3H4V10H19V6.5ZM19 6.5H22V13H12V15","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10 16H12H14V21H10V16Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FormatPainterIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'format-painter',
    ref,
    icon: element,
  },
));

FormatPainterIcon.displayName = 'FormatPainterIcon';

export default FormatPainterIcon;
